var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChartLayout',{attrs:{"title":`${_vm.title}${
    _vm.selectedProduct
      ? `, ${_vm.selectedProduct}`
      : ` by ${_vm.productLabel.toLowerCase()}`
  }, ${_vm.selectedRegion}`,"units":_vm.units},scopedSlots:_vm._u([{key:"params",fn:function(){return [_c('ControlGroup',[_c('Dropdown',{attrs:{"label":_vm.productLabel,"options":_vm.productOptions,"resetOnInvalid":"","small":""},model:{value:(_vm.selectedProduct),callback:function ($$v) {_vm.selectedProduct=$$v},expression:"selectedProduct"}})],1)]},proxy:true},(_vm.note)?{key:"notes",fn:function(){return [_vm._v(" "+_vm._s(_vm.note)+" ")]},proxy:true}:null],null,true)},[_c('Chart',{key:"capgrowth",attrs:{"options":_vm.buildOptions(
        {
          series: _vm.getFiveYearGrowth(_vm.flowData),
          chart: {
            height: 400,
          },
          xAxis: {
            type: 'category',
            plotBands: [
              {
                from: _vm.periods.length - 2 + 0.5,
                to: _vm.periods.length + 0.5,
                label: {
                  text: 'Forecast',
                },
              },
            ],
          },
          yAxis: {
            plotLines: [
              {
                value: 0,
                className: 'highcharts-zero-axis',
                zIndex: 999,
              },
            ],
          },
          tooltip: {
            valueSuffix: ` ${_vm.units}`,
          },
          legend: {
            enabled: !_vm.selectedProduct,
            align: 'right',
            verticalAlign: 'middle',
            layout: 'vertical',
            width: '20%',
            floating: false,
            reversed: true,
          },
        },
        'column'
      )}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }